import ModalGeneral from "../../common/scripts/ModalGeneralComponent";
import { ScoreComponent } from "./scoreComponent"
import { ModalForm } from "./modalForm"
import { ModalAyuda } from "./ModalHelpComponent"
import { Auditoria } from "./auditoriaObject"

export class IndexFlujoEncuesta extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      encuesta: "",
      paramForSurvey: props.dataToStorage.isCompleteSurvey.Name,
      count: 0,
      countItem: 0,
      progressPercent: 0,
      disabledbtnNext: true,
      active: null,
      complete:
        props.dataToStorage.isCompleteSurvey.IsCompleted === true
          ? true
          : false,
      checked: false,
      userInfo: props.dataToStorage.userInformation, // compTools.obtenerInformacionUsuario()
      autenticado: true, // compTools.estaAutenticado(),
      counterIco: "counterIco",
      counterResponse: "counterIcoResponse",
      counter: "counter",
      counterEmpty: "",
      scoreResult: [],
      totalQuestions: "",
      mock: {},
      dateFormat: "",
      idModal: resourcesEncuesta.getResource("es", "nsEncuesta", "ID"),
      nameCC: "",
      dropCC: "",
      numberId: "",
      emailUs: "",
      namePhone: "",
      placeMail: "",
      placePhone: "",
      availableInput: true,
      numberPhone: "",
      checkedAuth: false,
      updateOk: false,
      unknownUserValidation: false,
      messageModal: resourcesEncuesta.getResource(
        "es",
        "nsEncuesta",
        "Modal.subheading"
      ),
      auditoriaData: Auditoria,
      showModal: false,
      showModalHelp: false,
      showModalForm: false,
      activeHelpModal: null,
      typeModal: null,
      IPUser: "",
    };
    this.activeModal = this.activeModal.bind(this);
    this.handleModalFirstBtn = this.handleModalFirstBtn.bind(this);
    this.handleModalSecondBtn = this.handleModalSecondBtn.bind(this);
    this.activeModalHelp = this.activeModalHelp.bind(this);
    this.showHelpModal = this.showHelpModal.bind(this);
    console.log({dataToStorage: props.dataToStorage})
  }

  componentDidMount() {
    this.getDependencies()
  }

  redirectBackSurvey() {
    compensar.mostrarLoading("#Landing-Encuestas");
    // window.location.href =
    //   _spPageContextInfo.siteAbsoluteUrl +
    //   resourcesEncuesta.getResource(
    //     "es",
    //     "nsEncuesta",
    //     "Form.Redirects.LandingEncuestas"
    //   );
    this.props.handleVolverA2();
  }

  getDependencies() {
    compensar.arrCode = [];
    compensar.arrPoints = [];
    compensar.arrQuestionGroup = [];
    compensar.arrindexObj = [];
    compensar.arrindexObjAnswer = [];
    compensar.arrAnswer = [];
    this.getIP();
    this.getServiceEnuesta(this.state.paramForSurvey);
    this.props.dataToStorage.isCompleteSurvey.IsCompleted === true
      ? this.resultByUser()
      : null /*this.getScoreSurvey()*/;
    // this.setInLocalSecurityObj();
  }

  getIP() {
    jQuery.getJSON("https://api.ipify.org?format=json", (data) => {
      this.setState({
        IPUser: data.ip,
      });
    });
  }

  handleModalFirstBtn() {}

  handleModalSecondBtn() {
    // window.location.href =
    //   _spPageContextInfo.siteAbsoluteUrl +
    //   resourcesEncuesta.getResource(
    //     "es",
    //     "nsEncuesta",
    //     "Form.Redirects.LandingEncuestas"
    //   );
    this.props.handleVolverA2();
  }

  ServiceGet(url, proxy) {
    return new Promise((resolve, reject) => {
      const urlToService = new ServicioProxyTransar(url, proxy);
      urlToService
        .getDataFromServiceSurveys("GET", null)
        .then((response) => {
          if (response) {
            const data = JSON.parse(response);
            resolve(data);
          } else {
            reject(Error("Error en la consulta"));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  ServicePostAuditoria(obj, url, proxy) {
    return new Promise((resolve, reject) => {
      const urlToService = new ServicioProxyTransar(url, proxy);
      urlToService
        .getElements("POST", obj)
        .then((response) => {
          if (response) {
            const data = JSON.parse(response);
            resolve(data);
          } else {
            reject(Error("Error en la consulta"));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  ServicePost(obj, url, proxy) {
    return new Promise((resolve, reject) => {
      const urlToService = new ServicioProxyTransar(url, proxy);
      urlToService
        .getElementsSurveys("POST", obj)
        .then((response) => {
          if (response) {
            const data = JSON.parse(response);
            resolve(data);
          } else {
            reject(Error("Error en la consulta"));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  setDataRequestSaveResults(name) {
    var data = {};

    data.SurveyName = name.trim();
    data.UserTypeId = this.props.dataToStorage.userInformation.UserTypeId;
    data.UserId = this.props.dataToStorage.userInformation.UserId;
    /*OJO: REVISAR SI QUITAR SIGUIENTE LINEA*/
    //data.Points = this.concatPoints();
    data.Points = this.state.scoreResult.TotalPoints;
    data.Answers = compensar.arrQuestionGroup;

    return data;
  }

  setDataRequestToSaveAnonimousResult(name) {
    var data = {};

    data.SurveyName = name;
    data.UserTypeId = this.props.dataToStorage.userInformation.UserTypeId // this.state.dropCC;
    data.UserId = this.props.dataToStorage.userInformation.UserId // this.state.numberId;
    /*OJO: REVISAR SI QUITAR SIGUIENTE LINEA*/
    //data.Points = this.concatPoints();
    data.Points = this.state.scoreResult.TotalPoints;
    data.Answers = compensar.arrQuestionGroup;

    return data;
  }

  getServiceRegistrarAuditoria(
    transactionName,
    operationName,
    program,
    dataResult,
    flagData
  ) {
    this.ServicePostAuditoria(
      this.setDataRequestAuditoria(
        transactionName,
        operationName,
        program,
        dataResult,
        flagData
      ),
      "RegistrarAuditoriaED",
      "ServicioTransar.svc"
    )
      .then((data) => {})
      .catch((err) => {
        console.log(err);
      });
  }

  setDataRequestTipoIdentificacionUsuario(flagData) {
    return flagData
      ? compensar.responseUserLogged.UserTypeId
      : this.state.auditoriaData.Transaccion.EncuestasSalud.Funcionalidades
          .Encuestas.TipoIdentificacionUsuarioAnonimo;
  }

  setDataRequestNumeroIdentificacionUsuario(flagData) {
    return flagData
      ? compensar.responseUserLogged.UserId
      : this.state.auditoriaData.Transaccion.EncuestasSalud.Funcionalidades
          .Encuestas.NumeroIdentificacionUsuarioAnonimo;
  }

  setDataRequestTipoIdenficacionAfiliado(flagData) {
    return flagData
      ? compensar.responseUserLogged.UserTypeId
      : this.state.auditoriaData.Transaccion.EncuestasSalud.Funcionalidades
          .Encuestas.TipoIdenficacionAfiliadoAnonimo;
  }

  setDataRequestNumeroIdentificacionAfiliado(flagData) {
    return flagData
      ? compensar.responseUserLogged.UserId
      : this.state.auditoriaData.Transaccion.EncuestasSalud.Funcionalidades
          .Encuestas.NumeroIdentificacionAfiliadoAnonimo;
  }

  setDataRequestNombreAfiliado(flagData) {
    return flagData
      ? compensar.responseUserLogged.FullName
      : this.state.auditoriaData.Transaccion.EncuestasSalud.Funcionalidades
          .Encuestas.NombreUsuarioAnonimo;
  }

  getErrorModal(error, typeError) {
    const btnModalUno = resourcesEncuesta.getResource("es", "nsEncuesta", "Form.PopUp.NameButton.Aceptar");
    const btnModalDos = resourcesEncuesta.getResource("es", "nsEncuesta", "Form.PopUp.NameButton.Cerrar");
    const typeModal = resourcesEncuesta.getResource("es", "nsEncuesta", "Form.PopUp.NameButton.Cerrar")
    this.activeModal(
      "",
      resourcesEncuesta.getResource("es", "nsEncuesta", "Form.Modal.False"),
      error,
      resourcesEncuesta.getResource(
        "es",
        "nsEncuesta",
        "Form.Modal.Ico.Exclamation"
      ),
      resourcesEncuesta.getResource(
        "es",
        "nsEncuesta",
        "Form.Modal.Color.Blue"
      ),
      resourcesEncuesta.getResource("es", "nsEncuesta", "Form.Modal.False"),
      resourcesEncuesta.getResource(
        "es",
        "nsEncuesta",
        "Form.Modal.False"
      ),
      resourcesEncuesta.getResource("es", "nsEncuesta", "Form.Modal.True"),
      btnModalUno,
      btnModalDos,
      typeModal,
    );
  }

  setDataRequestAuditoria(
    transactionName,
    operationName,
    program,
    dataResult,
    flagData
  ) {
    var dataRequest = {};
    var dataDatosAdicionales = {};

    dataDatosAdicionales.NombreEncuesta = this.state.paramForSurvey;// this.props.dataToStorage.userInformation.FullName
    dataDatosAdicionales.Puntos = dataResult.TotalPoints;
    dataDatosAdicionales.Alerta = dataResult.Warning;
    dataDatosAdicionales.Mensaje = dataResult.Text;
    dataDatosAdicionales.Fecha = new Date();
    var DatosAdicionalesResult = JSON.stringify(dataDatosAdicionales);

    dataRequest.__type =
      "AuditoriaRequest:#Consorcio.Transar.Entities.Services.Auditoria";
    dataRequest.TipoIdentificacionUsuario = this.props.dataToStorage.userInformation.UserTypeId /* compTools.estaAutenticado()
      ? compTools.obtenerInformacionUsuario().TipoIdentificacion
      : this.setDataRequestTipoIdentificacionUsuario(flagData)*/;
    dataRequest.NumeroIdentificacionUsuario = this.props.dataToStorage.userInformation.UserId /* compTools.estaAutenticado()
      ? compTools.obtenerInformacionUsuario().LegalID
      : this.setDataRequestNumeroIdentificacionUsuario(flagData)*/;
    dataRequest.NombreUsuario = this.props.dataToStorage.userInformation.FullName // compTools.estaAutenticado()
      // ? compTools.obtenerInformacionUsuario().Nombre
      // : this.setDataRequestNombreAfiliado(flagData);
    dataRequest.ProgramaAfiliacion = program;
    dataRequest.Transaccion = transactionName;
    dataRequest.TipoIdenficacionAfiliado = this.props.dataToStorage.userInformation.UserTypeId;
    dataRequest.NumeroIdentificacionAfiliado = this.props.dataToStorage.userInformation.UserId;
    dataRequest.IPUsuario = this.state.IPUser;
    dataRequest.DatosAdicionales = DatosAdicionalesResult;

    return dataRequest;
  }

  getServiceSaveResults(name) {
    this.ServicePost(
      this.setDataRequestSaveResults(name),
      "SaveSurveyslResults",
      "ServicioTransarSurvey.svc"
    )
      .then((data) => {
        if (data.ResponseCode === 200) {
          console.log(data.Result);
        } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
          console.log(data.Result);
          compensar.quitarLoading("#Landing-Encuestas");
          this.getErrorModal(data.ResponseDetail, data.ResponseCode);
        } else if (data.ResponseCode === 430) {
          console.log(data.Result);
          compensar.quitarLoading("#Landing-Encuestas");
          this.getErrorModal(data.ResponseDetail, data.ResponseCode);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getServiceEnuesta(name) {
    compensar.mostrarLoading("#Landing-Encuestas");
    this.ServiceGet(
      "GetSurveyslQuestionnaire?surveyName=" + name,
      "ServicioTransarSurvey.svc"
    )
      .then((data) => {
        if (data.ResponseCode === 200) {
          this.setState({ encuesta: data.Result });
          compensar.quitarLoading("#Landing-Encuestas");
        } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
          compensar.quitarLoading("#Landing-Encuestas");
          this.getErrorModal(data.ResponseDetail, data.ResponseCode);
        } else if (data.ResponseCode === 430) {
          compensar.quitarLoading("#Landing-Encuestas");
          this.getErrorModal(data.ResponseDetail, data.ResponseCode);
        }
      })
      .catch((err) => {
        compensar.quitarLoading("#Landing-Encuestas");
        console.log(err);
      });
  }

  getServiceFinalProcess(name, points) {
    compensar.mostrarLoading("#Landing-Encuestas");
    this.ServiceGet(
      "GetSurveyResultsMessage?surveyName=" +
        name +
        "&&surveyTotalPoints=" +
        points,
      "ServicioTransarSurvey.svc"
    )
    .then((data) => {
      if (data.ResponseCode === 200) {
        this.getWaringModal(data.Result);
      } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
        compensar.quitarLoading("#Landing-Encuestas");
        this.getErrorModal(data.ResponseDetail, data.ResponseCode);
      } else if (data.ResponseCode === 430) {
        compensar.quitarLoading("#Landing-Encuestas");
        this.getErrorModal(data.ResponseDetail, data.ResponseCode);
      }
    })
    .catch((err) => {
      compensar.quitarLoading("#Landing-Encuestas");
      console.log(err);
    });
  }

  /*
    OJO: EVALUAR SI QUITAR COMENTARIOS
    concatPoints() {
        let suma = 0;

        for (var i = 0; compensar.arrPoints.length > i; i++) {
            suma += compensar.arrPoints[i];
        }

        return suma
    }
    */

  instanceServiceTotalProcess() {
    /*OJO: REVISAR SI QUITAR COMENTARIOS DE SIGUIENTE LINEA. ESTO PORQUE PRIMERO SE ESTÁ LLAMANDO EL GUARADO y LUEGO EL CALCULO DE PUNTAJE
         y DEBE SER LO CONTRARIO PRIMERO EL CALCULO LUEGO EL GUARDADO*/

    //compTools.estaAutenticado() ? this.getServiceSaveResults(this.state.paramForSurvey) : null
    //this.getScoreSurvey(compensar.arrQuestionGroup);

    //Llamado al servicio que calcula el puntaje final de la encuesta basado en la formula
    this.getScoreSurvey(compensar.arrQuestionGroup);
  }

  setDataRequestresultByUser() {
    var data = {};
    data.userTypeId = this.props.dataToStorage.userInformation.UserTypeId // this.state.userInfo.UserTypeId;
    data.userId = this.props.dataToStorage.userInformation.UserId;
    data.surveyName = this.props.dataToStorage.isCompleteSurvey.Name;

    return data;
  }

  resultByUser() {
    compensar.mostrarLoading("#Landing-Encuestas");
    this.ServicePost(
      this.setDataRequestresultByUser(),
      "GetSurveyslResultsByUser",
      "ServicioTransarSurvey.svc"
    )
    .then((data) => {
      if (data.ResponseCode === 200) {
        this.setState({
          scoreResult: {
            Risk: data.Result.Warning,
            Text: data.Result.Message,
            TotalPoints: data.Result.Points,
            Warning: data.Result.Warning,
          },
          dateFormat: data.Result.Date,
        });
      } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
        console.log(data.Result);
        this.getErrorModal(data.ResponseDetail, data.ResponseCode);
      } else if (data.ResponseCode === 430) {
        console.log(data.Result);
        this.getErrorModal(data.ResponseDetail, data.ResponseCode);
      }
      compensar.quitarLoading("#Landing-Encuestas");
    })
    .catch((err) => {
      compensar.quitarLoading("#Landing-Encuestas");
      console.log(err);
    });
  }

  setDataRequestScoreSurveys(arr) {
    const request = {};
    request.SurveyName = this.state.paramForSurvey;
    request.Answers = arr;
    return request;
  }

  //Se obtiene el puntaje total de la encuesta
  getScoreSurvey(arr) {
    compensar.mostrarLoading("#Landing-Encuestas");
    this.ServicePost(
      this.setDataRequestScoreSurveys(arr),
      "GetSurveyslScore",
      "ServicioTransarSurvey.svc"
    )
    .then((data) => {
      if (data.ResponseCode === 200) {
        if (data.Result == null) {
          this.getWaringModal(this.setDataToWarningModalNoLogued());
        } else {
          this.setState({
            scoreResult: data.Result,
            totalQuestions: this.state.mock,
          });

          //Se guarda el resultado en la lista SharePoint
          this.getServiceSaveResults(this.state.paramForSurvey)
          
          //Se invoca el servicio de auditoria del cliente
          this.getServiceRegistrarAuditoria(
            this.state.encuesta.Name,
            this.state.auditoriaData.Transaccion.Certificaciones
              .Funcionalidades.AportesAnuales.Valor,
            // compTools.estaAutenticado()
              // ? this.props.dataToStorage.userInformation.Program
              // : this.state.auditoriaData.Transaccion.EncuestasSalud.Funcionalidades.Encuestas.ProgramaUsuarioAnonimo,
            this.props.dataToStorage.userInformation.Program,
            data.Result,
            false
          );
        }
        compensar.quitarLoading("#Landing-Encuestas");
      } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
        compensar.quitarLoading("#Landing-Encuestas");
        this.getErrorModal(data.ResponseDetail, data.ResponseCode);
        console.log(data.Result);
      } else if (data.ResponseCode === 430) {
        console.log(data.Result);
        compensar.quitarLoading("#Landing-Encuestas");
        this.getErrorModal(data.ResponseDetail, data.ResponseCode);
      }
    })
    .catch((err) => {
      compensar.quitarLoading("#Landing-Encuestas");
      console.log(err);
    });
  }

  validateBifuracion(adding) {
    var ind = adding;
    var flag = true;
    this.state.encuesta.Questionnaire.map((ans, index) => {
      if (flag) {
        if (index >= adding) {
          if (ans.AnswerCode != "") {
            compensar.arrCode.map((code, innerIndex) => {
              if (code == ans.AnswerCode) {
                ind = index;
                flag = false;
                compensar.Bifurcacion = true;
              }
            });
          } else {
            flag = false;
            ind = index;
            compensar.Bifurcacion = false;
          }
        }
      }
    });
    return ind;
  }

  sliceArr(cant) {
    compensar.arrCode = compensar.arrCode.slice(0, cant);
    compensar.arrPoints = compensar.arrPoints.slice(0, cant);
    compensar.arrindexObj = compensar.arrindexObj.slice(0, cant);
    compensar.arrindexObjAnswer = compensar.arrindexObjAnswer.slice(0, cant);
    compensar.arrAnswer = compensar.arrAnswer.slice(0, cant);
    compensar.arrQuestionGroup = compensar.arrQuestionGroup.slice(0, cant);

    this.setState({ disabledbtnNext: true, active: null, checked: false });
  }

  addItem(add, bifurcacion) {
    compensar.arrCode[add - 1] = compensar.itemAnswer.answerCode;
    compensar.arrPoints[add - 1] = compensar.itemAnswer.Points;
    compensar.arrindexObj[add - 1] = compensar.itemAnswer.indexObj;
    compensar.arrindexObjAnswer[add - 1] = compensar.itemAnswer.indexObjAnswer;
    compensar.arrAnswer[add - 1] = compensar.itemAnswer.answer;
    compensar.arrQuestionGroup[add - 1] = compensar.itemAnswer.groupQuestion;
    compensar.itemAnswer.indexObjAnswer = compensar.arrindexObjAnswer[add];

    this.setState({ active: compensar.arrindexObjAnswer[add] });
    bifurcacion ? this.sliceArr(add) : null;
  }

  setDataToArrays() {
    compensar.arrCode.push(compensar.itemAnswer.answerCode);
    compensar.arrQuestionGroup.push(compensar.itemAnswer.groupQuestion);
    compensar.arrPoints.push(compensar.itemAnswer.Points);
    compensar.arrindexObj.push(compensar.itemAnswer.indexObj);
    compensar.arrindexObjAnswer.push(compensar.itemAnswer.indexObjAnswer);
    compensar.arrAnswer.push(compensar.itemAnswer.answer);
  }

  nextQuestion() {
    var adding = (this.state.count += 1);
    var addingItem = (this.state.countItem += 1);
    const complete = adding == this.state.encuesta.Questionnaire.length
      ? true
      : false;
    this.setState({ complete });
    if (complete) {
      this.setDataToArrays();
      this.instanceServiceTotalProcess();
    }
    
    if (this.state.countItem > compensar.arrindexObjAnswer.length) {
      this.setState({ disabledbtnNext: true, active: null, checked: false });
      this.setDataToArrays();
    } else {
      if (this.state.countItem == compensar.arrindexObjAnswer.length) {
        this.setState({ disabledbtnNext: true, active: null, checked: false });
        if (
          compensar.arrindexObjAnswer[addingItem - 1] !=
          compensar.itemAnswer.indexObjAnswer
        ) {
          this.validateBifuracion(adding);
          compensar.Bifurcacion
            ? this.addItem(addingItem, compensar.Bifurcacion)
            : this.addItem(addingItem, compensar.Bifurcacion);
        }
      } else {
        this.setState({ disabledbtnNext: false });
        if (
          compensar.arrindexObjAnswer[addingItem - 1] ==
          compensar.itemAnswer.indexObjAnswer
        ) {
          this.getAnswer(
            compensar.arrAnswer[addingItem],
            compensar.arrindexObj[addingItem],
            compensar.arrindexObjAnswer[addingItem],
            this.state.encuesta.Questionnaire[adding].Code
          );
        } else {
          this.validateBifuracion(adding);
          compensar.Bifurcacion
            ? this.addItem(addingItem, compensar.Bifurcacion)
            : this.addItem(addingItem, compensar.Bifurcacion);
        }
      }
    }

    const count = this.validateBifuracion(adding);
    const progressPercent = this.percent(adding);
    const finalizar = count + 1 == this.state.encuesta.Questionnaire.length
      ? true
      : false;
    this.setState({ 
      count,
      countItem: addingItem,
      progressPercent,
      finalizar,
    });
  }

  previusQuestion() {
    const adding = this.state.count - 1;
    const addingItem = this.state.countItem - 1;
    const count = compensar.arrindexObj[addingItem];
    const progressPercent = this.percent(adding);
    const finalizar = count + 1 == this.state.encuesta.Questionnaire.length
          ? true
          : false;
    this.setState({
      checked: true,
      disabledbtnNext: false,
      count: count,
      countItem: addingItem,
      active: compensar.arrindexObjAnswer[addingItem],
      progressPercent,
      finalizar,
    });
    this.getAnswer(
      compensar.arrAnswer[addingItem],
      compensar.arrindexObj[addingItem],
      compensar.arrindexObjAnswer[addingItem],
      this.state.encuesta.Questionnaire[count].Code,
    );
  }

  disabledNextButton() {
    var bolean = "";
    if (this.state.encuesta.Questionnaire) {
      this.state.encuesta.Questionnaire.length == this.state.count + 1
        ? (bolean = false)
        : (bolean = true);
    }
    return bolean;
  }

  disabledPreviustButton() {
    var bolean = "";
    if (this.state.encuesta.Questionnaire) {
      this.state.count + 1 > 1 ? (bolean = true) : (bolean = false);
    }
    return bolean;
  }

  getAnswer(answer, index, indexAnswer, code) {
    var AnsewerToAdd = {};
    var AnsewerQuestionToAdd = {};

    AnsewerQuestionToAdd.SurveyQuestionCode = code;
    AnsewerQuestionToAdd.SurveyAnswerCode = answer.Code;

    AnsewerToAdd.answer = answer;
    AnsewerToAdd.answerCode = answer.Code;
    AnsewerToAdd.Points = answer.Points;
    AnsewerToAdd.indexObj = index;
    AnsewerToAdd.indexObjAnswer = indexAnswer;
    AnsewerToAdd.groupQuestion = AnsewerQuestionToAdd;
    compensar.itemAnswer = AnsewerToAdd;

    this.setState({
      disabledbtnNext: false,
      active: indexAnswer,
      checked: true,
    });
  }

  percent(items) {
    var current = items;
    var total = this.state.encuesta.Questionnaire.length;
    var resultParcial = current / total;
    var resultTotal = resultParcial * 100;
    const progressPercent = Math.floor(resultTotal);
    // this.setState({ progressPercent });
    return progressPercent;
  }

  styleProgress(numberW) {
    var obj = {};
    obj.width = numberW + "%";
    return obj;
  }

  setDataToWarningModalNoLogued() {
    var data = {};
    data.Warning = "";
    data.Risk = resourcesEncuesta.getResource(
      "es",
      "nsEncuesta",
      "Form.PopUp.Contenido.SinRango"
    );
    data.Text = "";

    return data;
  }

  contentWarningPopUp(data) {
    return (
      <div>
        <div>
          <p>{data.Risk == "" ? "" : data.Risk}</p>
        </div>
        <div>
          <p>{data.Text}</p>
        </div>
      </div>
    );
  }

  getWaringModal(data) {
    const btnModalUno = resourcesEncuesta.getResource(
      "es",
      "nsEncuesta",
      "Form.PopUp.BtnVisible.No"
    );
    const btnModalDos = resourcesEncuesta.getResource(
      "es",
      "nsEncuesta",
      "Form.PopUp.BtnVisible.Aceptar"
    )
      
    this.activeModal(
      data != null ? data.Warning : "",
      resourcesEncuesta.getResource("es", "nsEncuesta", "Form.Modal.True"),
      data != null
        ? this.contentWarningPopUp(data)
        : resourcesEncuesta.getResource(
            "es",
            "nsEncuesta",
            "Form.PopUp.Contenido.SinDataRespuesta"
          ),
      resourcesEncuesta.getResource(
        "es",
        "nsEncuesta",
        "Form.Modal.Ico.Exclamation"
      ),
      resourcesEncuesta.getResource(
        "es",
        "nsEncuesta",
        "Form.Modal.Color.Blue"
      ),
      resourcesEncuesta.getResource("es", "nsEncuesta", "Form.Modal.False"),
      resourcesEncuesta.getResource("es", "nsEncuesta", "Form.Modal.False"),
      resourcesEncuesta.getResource("es", "nsEncuesta", "Form.Modal.True"),
      btnModalUno,
      btnModalDos,
    );
  }

  activeModal(
    title,
    btnCerrarCancelar,
    message,
    icono,
    colorIco,
    noX,
    noAceptar,
    noCancelar,
    btnModalUno,
    btnModalDos,
    typeModal,
  ) {
    if (btnModalUno) {
      this.setState({
        titleModal: title,
        btnCerrarCancelar: btnCerrarCancelar,
        messageModal: message,
        iconoModal: icono,
        colorIco: colorIco,
        noX: noX,
        noAceptar: noAceptar,
        noCancelar: noCancelar,
        showModal: true,
        // solo debo actualizarlo si viene
        btnModalUno,
        btnModalDos,
        typeModal,
      });
      
    } else {
      this.setState({
        titleModal: title,
        btnCerrarCancelar: btnCerrarCancelar,
        messageModal: message,
        iconoModal: icono,
        colorIco: colorIco,
        noX: noX,
        noAceptar: noAceptar,
        noCancelar: noCancelar,
        showModal: true,
      });
    }
    // this.refs.activeModal.handleShow();
  }
  activeModalHelp(
    title,
    btnCerrarCancelar,
    message,
    icono,
    colorIco,
    noX,
    noAceptar,
    noCancelar
  ) {
    this.setState({
      titleModal: title,
      btnCerrarCancelar: btnCerrarCancelar,
      messageModal: message,
      iconoModal: icono,
      colorIco: colorIco,
      noX: noX,
      noAceptar: noAceptar,
      noCancelar: noCancelar,
      showModalHelp: true,
    });
    // this.refs.activeModalHelp.handleShow();
  }

  setTypeClass(Type) {
    var classN = "";
    switch (Type) {
      case "Cerrada dicotómica":
        classN = "cerradaDic";
        break;
      case "Cerrada politómica":
        classN = "cerradaPoli";
        break;
      case "Escala numérica":
        classN = "escalaNum";
        break;
      case "Escala nominal":
        classN = "escalaNom";
        break;
    }

    return classN;
  }

  extractHostname(url) {
    let hostname;
    //find & remove protocol (http, ftp, etc.) and get hostname

    if (url.indexOf("//") > -1) {
      hostname = url.split("/")[2];
    } else {
      hostname = url.split("/")[0];
    }

    //find & remove "?"
    hostname = hostname.split("?")[0];

    return hostname;
  }

  showHelpModal(url) {
    let newUrl = url.replace("http://", "https://");
    let hostNameUrl = this.extractHostname(newUrl);
    let windowUrl = window.location.hostname;
    if (hostNameUrl != windowUrl) {
      newUrl = newUrl.replace(hostNameUrl, windowUrl);
    }
    this.setState({
        activeHelpModal: newUrl + "?isdlg=1",
    })
    this.activeModalHelp(
      // resourcesEncuesta.getResource("es", "nsEncuesta", "IMC.Titulo"),
      this.state.encuesta.Questionnaire[this.state.count]
        .HelpLinkDescription
        ? this.state.encuesta.Questionnaire[this.state.count]
            .HelpLinkDescription
        : "",
      resourcesEncuesta.getResource("es", "nsEncuesta", "Form.Modal.True"),
      "",
      "",
      "",
      resourcesEncuesta.getResource("es", "nsEncuesta", "Form.Modal.True"),
      resourcesEncuesta.getResource("es", "nsEncuesta", "Form.Modal.False"),
      resourcesEncuesta.getResource("es", "nsEncuesta", "Form.Modal.False")
    );
  }

  renderProgressComponent(desktop) {
    return (
      <div
        className={
          desktop
            ? "col-xs-12 col-sm-12 col-md-12 col-lg-12 percentage noMobile"
            : "col-xs-12 col-sm-12 col-md-12 col-lg-12 percentage mobile"
        }
      >
        <div>
          {this.state.dateFormat === "" ? (
            <div>
              {this.state.encuesta.Questionnaire == undefined ? (
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 container">
                  <h4>
                    {resourcesEncuesta.getResource(
                      "es",
                      "nsEncuesta",
                      "Form.General.progress"
                    )}
                  </h4>
                  <div className="progress-bar">
                    <div
                      className="progress"
                      style={this.styleProgress(0)}
                    ></div>
                  </div>
                </div>
              ) : this.state.countItem + 1 > 1 ? (
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 container">
                  <h4>
                    {this.state.progressPercent +
                      resourcesEncuesta.getResource(
                        "es",
                        "nsEncuesta",
                        "Form.General.progressConcat"
                      )}
                  </h4>
                  <div className="progress-bar">
                    <div
                      className="progress"
                      style={this.styleProgress(this.state.progressPercent)}
                    ></div>
                  </div>
                </div>
              ) : (
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 container">
                  <h4>
                    {resourcesEncuesta.getResource(
                      "es",
                      "nsEncuesta",
                      "Form.General.progress"
                    )}
                  </h4>
                  <div className="progress-bar">
                    <div
                      className="progress"
                      style={this.styleProgress(0)}
                    ></div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>
              <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 container">
                <h4>
                  {resourcesEncuesta.getResource(
                    "es",
                    "nsEncuesta",
                    "Form.General.progressComplete"
                  )}
                </h4>
                <div className="progress-bar">
                  <div
                    className="progress"
                    style={this.styleProgress(100)}
                  ></div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderTitle(empty) {
    return (
      <div className="header-section">
        <h2>
          {empty
            ? "No se encuentra La Encuesta Disponible"
            : this.state.encuesta.Name + (this.state.autenticado ? " | " : "")}
        </h2>
        <p>
          {this.state.userInfo != undefined ? this.state.userInfo.Nombre : null}
        </p>
      </div>
    );
  }

  renderCounterIco(classIco, fontAwesome) {
    let icon;
    let background;

    if (
      this.state.scoreResult.Warning == "Ligeramente Alto" ||
      this.state.scoreResult.Warning == "Moderado"
    ) {
      icon = "info-circle colorYellow";
      background = " bgYellow";
    } else if (
      this.state.scoreResult.Warning == "Alto" ||
      this.state.scoreResult.Warning == "Muy Alto"
    ) {
      icon = "medkit colorRed";
      background = " bgRed";
    } else if (
      this.state.scoreResult.Warning == "Muy Bajo" ||
      this.state.scoreResult.Warning == "Bajo"
    ) {
      icon = "thumbs-up colorGreen";
      background = " bgGreen";
    } else {
      background = "";
    }
    return (
      <div className={"counter " + classIco + background}>
        {classIco == "" ? (
          this.state.countItem + 1
        ) : classIco != "counterIco" ? (
          <i
            className={
              fontAwesome +
              `${icon === undefined ? "thumbs-up colorWhite" : icon}`
            }
          ></i>
        ) : (
          <i className="fa fa-check-circle"></i>
        )}
      </div>
    );
  }

  renderItemAnswer(answer, index) {
    return (
      <li
        className={
          this.state.active == index ? "active option" : "noActive option"
        }
      >
        <button
          className="col-xs-12 col-sm-12 col-md-6 col-lg-6 btn btn-primary"
          type="button"
          onClick={this.getAnswer.bind(
            this,
            answer,
            this.state.count,
            index,
            this.state.encuesta.Questionnaire[this.state.count].Code
          )}
        >
          {answer.ShowImage ? <img src={answer.ImageUrl} /> : null}
          <p>{answer.Text}</p>
        </button>
      </li>
    );
  }

  renderQuestions() {
    const HelpLinkValue =
      this.state.encuesta.Questionnaire[this.state.count].HelpLinkValue.split(
        ","
      );
    return (
      <div>
        {this.state.encuesta.Questionnaire == undefined ||
        this.state.encuesta.Questionnaire.length == 0 ? null : (
          <div>
            {this.renderProgressComponent(false)}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              className="clearfix question-container"
            >
              <h2
                className="col-xs-12 col-sm-12 col-md-12 col-lg-12 question-title"
                style={{
                  maxWidth: "528px",
                }}
              >
                {this.state.encuesta.Questionnaire[this.state.count].Text}
              </h2>
              {this.state.encuesta.Questionnaire[this.state.count]
                .HasHelpLink ? (
                <div
                  className="alert alert-info"
                  onClick={this.showHelpModal.bind(this, HelpLinkValue[0])}
                  style={{
                    maxHeight: "54px",
                    marginLeft: "15px",
                    marginRight: "10px",
                    marginBottom: "0px",
                    position: "inherit",
                    cursor: 'pointer',
                  }}
                >
                  <i className="fa fa-info-circle" />
                  <p style={{
                    display: 'inline-block',
                    marginLeft: '10px',
                    verticalAlign: 'middle',
                    minWidth: '80px',
                  }}>
                    {
                      this.state.encuesta.Questionnaire[this.state.count]
                        .HelpLinkDescription
                    }
                  </p>
                </div>
              ) : null}
            </div>

            <ul
              className={
                this.setTypeClass(
                  this.state.encuesta.Questionnaire[this.state.count].Type
                ) + " clearfix"
              }
            >
              {this.state.encuesta.Questionnaire[this.state.count].Answers.map(
                (answer, index) => {
                  return this.renderItemAnswer(answer, index);
                }
              )}
            </ul>
          </div>
        )}
      </div>
    );
  }

  calculateMonths() {
    let days =
      this.props.dataToStorage.isCompleteSurvey
        .Periodicity;
    let percent = 30.417;
    let data = days / percent;
    const showData = Math.round(data) + " meses";
    return showData;
  }
  renderPlantilla() {
    return (
      <div>
        <div>
          {this.renderProgressComponent(false)}
          {this.state.dateFormat !== "" ? (
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 question-title">
              <h5 className="headDate">
                {resourcesEncuesta.getResource(
                  "es",
                  "nsEncuesta",
                  "Score.headComplete"
                )}
              </h5>
              <br />
              <p className="completeDate">
                Realizaste esta encuesta el{" "}
                {moment(this.state.dateFormat).format("DD MMMM YYYY")}.{" "}
                {resourcesEncuesta.getResource(
                  "es",
                  "nsEncuesta",
                  "Score.subheadingComplete"
                ) + this.calculateMonths()}
              </p>
            </div>
          ) : (
            <h2 className="col-xs-12 col-sm-12 col-md-12 col-lg-12 question-title">
              {resourcesEncuesta.getResource(
                "es",
                "nsEncuesta",
                "Score.heading"
              )}
            </h2>
          )}
        </div>
        <div>
          <ScoreComponent
            Score={this.state.scoreResult}
            Total={this.state.totalQuestions}
            Date={this.state.dateFormat}
          />
        </div>
      </div>
    );
  }

  loggedOn() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 question-footer">
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 loggedOne">
          <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
            <i
              className={resourcesEncuesta.getResource(
                "es",
                "nsEncuesta",
                "Score.faIcon"
              )}
            ></i>
          </div>
          <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
            <p>
              {resourcesEncuesta.getResource(
                "es",
                "nsEncuesta",
                "Score.informativeText"
              )}
            </p>
          </div>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 loggedButton">
          {/* {this.state.scoreResult.Warning !== "Muy Bajo" ? (
            <button
              type="button"
              className="btn btn-default"
              onClick={this.redirectCita.bind(this)}
            >
              {resourcesEncuesta.getResource(
                "es",
                "nsEncuesta",
                "Score.btnCita"
              )}
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-default"
              onClick={this.redirectPlans.bind(this)}
            >
              {resourcesEncuesta.getResource(
                "es",
                "nsEncuesta",
                "Score.btnPlans"
              )}
            </button>
          )} */}
          {
            this.state.scoreResult.Warning === 'Alto' && 
            <button
              type="button"
              className="btn btn-default"
              onClick={this.redirectCita.bind(this)}
              style={{marginTop: '20px', padding: '14px 25px'}}
            >
              {resourcesEncuesta.getResource(
                "es",
                "nsEncuesta",
                "Score.btnCita"
              )}
            </button>
          }
          <button type="button" className="btn btn-primary"
            onClick={this.redirectLanding.bind(this)}
            style={{marginTop: '20px', padding: '12px 25px'}}
          >
            Volver a encuestas
          </button>
        </div>
      </div>
    );
  }

  openForm() {
    this.setState({ showModalForm: true });
    setTimeout(() => {
      Array.prototype.slice
        .call(document.querySelectorAll(".send.btn-default.last"))
        .forEach((btn) => {
          btn.disabled = true;
        });
    }, 1000);
  }

  handleHideModal(nameState) {
    this.setState({ [nameState]: false })
  }

  redirectPlans() {
    window.location.href = resourcesEncuesta.getResource(
      "es",
      "nsEncuesta",
      "Score.redirectPlanes"
    );
  }

  redirectCita() {
    window.location.href =
      _spPageContextInfo.siteAbsoluteUrl +
      resourcesEncuesta.getResource("es", "nsEncuesta", "Score.redirectCita");
  }

  redirectLanding() {
    compensar.mostrarLoading("#Landing-Encuestas");
    this.props.handleVolverA2();
  }

  redirectSurveyLogueo() {
    window.location.href =
      _spPageContextInfo.siteAbsoluteUrl +
      resourcesEncuesta.getResource(
        "es",
        "nsEncuesta",
        "Score.redirectLanding"
      );
  }

  buttonsProgress() {
    return (
      <div className=" col-xs-12 col-sm-12 col-md-12 col-lg-12 question-footer">
        <div className=" col-xs-12 col-sm-7 col-md-8 col-lg-8 survey-info">
          <p>{this.state.encuesta.Description}</p>
        </div>
        {this.state.complete ? null : (
          <div className=" col-xs-12 col-sm-5 col-md-4 col-lg-4 buttons">
            {this.disabledPreviustButton() ? (
              <button
                className="btn btn-primary"
                type="button"
                onClick={this.previusQuestion.bind(this)}
              >
                {resourcesEncuesta.getResource(
                  "es",
                  "nsEncuesta",
                  "Form.Botones.Anterior"
                )}
              </button>
            ) : null}
            <button
              className="btn btn-default"
              disabled={this.state.disabledbtnNext}
              type="button"
              onClick={this.nextQuestion.bind(this)}
            >
              {this.state.finalizar
                ? resourcesEncuesta.getResource(
                    "es",
                    "nsEncuesta",
                    "Form.Botones.Finalizar"
                  )
                : resourcesEncuesta.getResource(
                    "es",
                    "nsEncuesta",
                    "Form.Botones.Siguiente"
                  )}
            </button>
          </div>
        )}
      </div>
    );
  }

  selectDropModal(event) {
    this.setState({
      nameCC: event.name,
      dropCC: event.code,
    });
    compensar.inputSelect = true;
    this.validateBtnModal();
  }

  getInputIdentificationUser(e) {
    this.setState({
      numberId: e.target.value,
    });
  }

  getInputEmailUser(e) {
    this.validateEmailInput(e.target.value);
    this.setState({
      emailUs: e.target.value,
    });
  }

  validateEmailInput(text) {
    const re =
      /^(([^<>()[\]{\}\\\/.,;:#$%&=~+¿?¡!^*¨'`´áéíóúñÁÉÍÓÚÑ\s@\"]+(\.[^<>()[\]{\}\\\/.,;:#$%&=~+¿?¡!^*¨'`´áéíóúñÁÉÍÓÚ\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

    return re.test(String(text).toLowerCase());
  }

  getInputPhoneUser(e) {
    if (e.target.value.length >= 7 && this.validateNumbers(e.target.value)) {
      this.setState({
        placePhone: e.target.value,
      });
    }
  }

  validateNumbers(text) {
    if (/^[0-9]*$/.test(text) && text !== "") {
      return true;
    } else {
      return false;
    }
  }

  updateInfoUser() {
    if (this.state.unknownUserValidation === true) {
      this.setState({
        updateOk: true,
      });
    } else {
      let sendRequest = {
        userTypeId: this.state.dropCC,
        userId: this.state.numberId,
        email:
          this.state.emailUs === "" ? this.state.placeMail : this.state.emailUs,
        cellPhone:
          this.state.numberPhone === this.state.placePhone
            ? this.state.numberPhone
            : this.state.placePhone,
      };

      this.ServicePost(
        this.setDataRequestToSaveAnonimousResult(this.state.paramForSurvey),
        "SaveSurveyslResults",
        "ServicioTransarSurvey.svc"
      )
        .then((data) => {
          if (data.ResponseCode === 200) {
            console.log(data.Result);
          } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
            console.log(data.Result);
            compensar.quitarLoading("#Landing-Encuestas");
            this.getErrorModal(data.ResponseDetail, data.ResponseCode);
          } else if (data.ResponseCode === 430) {
            console.log(data.Result);
            compensar.quitarLoading("#Landing-Encuestas");
            this.getErrorModal(data.ResponseDetail, data.ResponseCode);
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.ServicePost(
        sendRequest,
        "CheckSurveyAnonymousUser",
        "ServicioTransarSurvey.svc"
      )
        .then((data) => {
          if (data.ResponseCode === 200) {
            if (data.Result !== null) {
              compensar.responseUserLogged = data.Result;
              this.setState({
                updateOk: true,
                messageModal: resourcesEncuesta.getResource(
                  "es",
                  "nsEncuesta",
                  "Modal.subheadingCompleteTrue"
                ),
              });
              this.getServiceRegistrarAuditoria(
                this.state.auditoriaData.Transaccion.EncuestasSalud.Nombre,
                this.state.auditoriaData.Transaccion.Certificaciones
                  .Funcionalidades.AportesAnuales.Valor,
                data.Result.AffiliatedAccessChecker.Program,
                this.state.scoreResult,
                true
              );
            } else {
              this.setState({
                updateOk: false,
                messageModal: resourcesEncuesta.getResource(
                  "es",
                  "nsEncuesta",
                  "Modal.subheadingCompleteTrue"
                ),
              });
            }
          } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
            console.log(data.Result);
            compensar.quitarLoading("#Landing-Encuestas");
            this.getErrorModal(data.ResponseDetail, data.ResponseCode);
          } else if (data.ResponseCode === 430) {
            console.log(data.Result);
            compensar.quitarLoading("#Landing-Encuestas");
            this.getErrorModal(data.ResponseDetail, data.ResponseCode);
          }
        })
        .catch((err) => {
          compensar.quitarLoading("#Landing-Encuestas");
          console.log(err);
        });
    }
  }

  validateInfoUser() {
    const sendRequest = {
      userTypeId: this.state.dropCC,
      userId: this.state.numberId,
    };
    this.ServicePost(
      sendRequest,
      "CheckSurveyAnonymousUser",
      "ServicioTransarSurvey.svc"
    )
      .then((data) => {
        if (data.ResponseCode == 200) {
          if (data.Result != null) {
            compensar.responseUserLogged = data.Result;
            this.setState(
              {
                placeName: data.Result.FullName,
                placeMail: data.Result.AffiliatedAccessChecker.Email,
                placePhone: data.Result.AffiliatedAccessChecker.CellPhone,
                availableInput: false,
              },
              () => {
                this.getPlaceholdeData(
                  this.state.placeName,
                  this.state.placePhone,
                  this.state.placeMail
                );
              }
            );
          } else {
            this.setState({
              unknownUserValidation: true,
              availableInput: false,
              messageModal: resourcesEncuesta.getResource(
                "es",
                "nsEncuesta",
                "Modal.subheadingCompleteFalse"
              ),
            });
          }
        } else if (data.ResponseCode == 500 || data.ResponseCode == 450) {
          compensar.quitarLoading("#Landing-Encuestas");
          this.getErrorModal(data.ResponseDetail, data.ResponseCode);
        } else if (data.ResponseCode == 430) {
          compensar.quitarLoading("#Landing-Encuestas");
          this.getErrorModal(data.ResponseDetail, data.ResponseCode);
        }
      })
      .catch((err) => {
        compensar.quitarLoading("#Landing-Encuestas");
        console.log(err);
      });
  }

  getPlaceholdeData(name, phoneNumber, email) {
    let inputPhone = document.querySelector("#inputTel");
    let inputEmail = document.querySelector("#inputMail");
    let inputName = document.querySelector("#inputName");
    inputPhone.value = phoneNumber;
    inputEmail.value = email;
    inputName.value = name;
    if (name !== "" && phoneNumber !== "" && email !== "") {
      compensar.inputId = true;
      compensar.inputTel = true;
      compensar.inputMail = true;
    }
  }

  redirectLandingTimeOut() {
    setTimeout(() => {
      this.redirectLanding();
    }, 1500);
  }

  validateBtnModal() {
    // Validación cuando el formulario tiene los campos Teléfono, Email y Nombre activos
    // let valido = compensar.inputTel && compensar.inputId && compensar.inputMail && compensar.inputChecked && compensar.inputSelect
    let valido =
      compensar.inputId && compensar.inputChecked && compensar.inputSelect;
    valido
      ? Array.prototype.slice
          .call(document.querySelectorAll(".send.btn-default.last"))
          .forEach((btn) => {
            btn.disabled = false;
          })
      : Array.prototype.slice
          .call(document.querySelectorAll(".send.btn-default.last"))
          .forEach((btn) => {
            btn.disabled = true;
          });
  }

  getCheckBoxOption() {
    let arrayCheckbox = Array.prototype.slice.call(
      document.querySelectorAll("#accept")
    );
    arrayCheckbox.forEach((item) => {
      if (item.checked === true) {
        compensar.inputChecked = true;
        this.validateBtnModal();
        this.setState({
          checkedAuth: true,
        });
      } else {
        compensar.inputChecked = false;
        this.validateBtnModal();
        this.setState({
          checkedAuth: false,
        });
      }
    });
  }

  render() {
    return (
      <div id="EncuestaStyled" className="selectorPadre">
        <div className="loadingWraper">
          <div className="compensarLoading">
            <span>cargando... </span>
          </div>
        </div>
        {this.state.encuesta == "" ? (
          <div>{this.renderTitle(true)}</div>
        ) : (
          <div>
            {this.renderTitle(false)}
            {this.renderProgressComponent(true)}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 question">
              {this.state.checked
                ? this.renderCounterIco(this.state.counterIco)
                : this.state.complete
                ? this.renderCounterIco(this.state.counterResponse, "fa fa-")
                : this.renderCounterIco(this.state.counterEmpty)}
              {this.state.complete
                ? this.renderPlantilla()
                : this.renderQuestions()}
            </div>
            <div>
              {this.state.complete === false
                ? this.buttonsProgress()
                : this.loggedOn()}
              {
                !this.state.complete &&
                <button type="button" className="btn btn-primary"
                  onClick={this.redirectLanding.bind(this)}
                  style={{marginTop: '20px', padding: '12px 25px'}}
                >
                  Volver a encuestas
                </button>
              }
            </div>
            {this.state.showModalForm &&
              <ModalForm
                // Code Survey
                CodeDrop={this.state.codeCC}
                // Text
                TitleDropdown={this.state.nameCC}
                DataDrowdown={this.state.idModal}
                MessageModal={this.state.messageModal}
                // Data User
                DataIdUser={this.state.numberId}
                DataPlaceholderName={this.state.placeName}
                DataPlaceholderMail={this.state.placeMail}
                DataPlaceholderPhone={this.state.placePhone}
                // Get Data InputForm Events
                GetInputEmail={this.getInputEmailUser.bind(this)}
                GetInputPhone={this.getInputPhoneUser.bind(this)}
                GetInputDropdown={this.selectDropModal.bind(this)}
                GetInputCheck={this.getCheckBoxOption.bind(this)}
                GetInputIdentification={this.getInputIdentificationUser.bind(
                  this
                )}
                UpdateInfoUserEvent={this.updateInfoUser.bind(this)}
                ValidateInfoUserEvent={this.validateInfoUser.bind(this)}
                // Booleans Disabled
                DisableInputCheck={this.state.checkedAuth}
                DisableInputForm={this.state.availableInput}
                ShowContent={this.state.updateOk}
                // Action Buttons Modal
                AltButtonAction={this.handleModalAcceptForm}
                showModal={this.state.showModalForm}
                handleHideModal={this.handleHideModal.bind(this)}
                handleVolverA2={this.props.handleVolverA2}
              />
            }
            <ModalGeneral
              MessageTitle={this.state.titleModal}
              msg={this.state.messageModal}
              Icono={this.state.iconoModal}
              colorIco={this.state.colorIco}
              NoX={this.state.noX}
              NoAceptar={this.state.noAceptar}
              NoCancelar={this.state.noCancelar}
              MainButtonText={this.state.btnModalUno}
              AltButtonText={this.state.btnModalDos}
              MainButtonAction={this.handleModalFirstBtn}
              AltButtonAction={this.handleModalSecondBtn}
              showModal={this.state.showModal}
              handleHideModal={this.handleHideModal.bind(this)}
            />
            {this.state.showModalHelp &&
              <ModalAyuda
                MessageTitle={this.state.titleModal}
                Icono={this.state.iconoModal}
                colorIco={this.state.colorIco}
                NoX={this.state.noX}
                NoAceptar={this.state.noAceptar}
                NoCancelar={this.state.noCancelar}
                MainButtonText={this.state.btnModalUno}
                AltButtonText={this.state.btnModalDos}
                MainButtonAction={this.handleModalFirstBtn}
                AltButtonAction={this.handleModalSecondBtn}
                CloseAction={this.handleModalFirstBtn}
                showModal={this.state.showModalHelp}
                handleHideModal={this.handleHideModal.bind(this)}
              >
                {this.state.activeHelpModal ? (
                  <iframe
                    src={this.state.activeHelpModal}
                    style={{
                      minHeight: "325px",
                    }}
                  />
                ) : null}
              </ModalAyuda>
            }
          </div>
        )}
      </div>
    );
  }
}
